<div class="container">
  <div class="title">{{title}}</div>
  <div class="phrases">
    <div *ngFor="let phrase of bank; trackBy: trackByFn; index as index"
      [ngClass]="{first:index == idx - 1, second: index == idx, third: index == idx + 1, fourth:index == idx + 2}"
    >{{phrase}}</div>
  </div>
</div>
